module.exports = __webpack_public_path__ + "static/media/responsive-lacruz.2493abad.png";